import { defineStore } from "pinia";

import { Create, Update } from "../../service/user/interface/user.interface";
import userService from "../../service/user/user.service";
import { storeItem } from "../../core/utils/storage.helper";

interface State {
  error: { value: boolean; type: any | null; message: string | null };
}
const userStore = defineStore("user", {
  state: (): State => ({
    error: { value: false, type: null, message: null },
  }),

  actions: {
    // async show(id: string): Promise<any> {
    //   try {
    //     const response = await userService.show(id);
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    async show(userId: number): Promise<any> {
      try {
        const response = await userService.show(userId);
        if (response && response.data && response.data.data) {
          console.log("_____\\\\\\\\_____",response.data.data.employee.user.email);
          console.log("_____*******_____",response.data.data.employee.id);
          console.log("_____=======_____",response.data.data.employee.user.phone.number);
          const data = JSON.stringify({
            customerInfo: {
              firstName: response.data.data.employee.user.firstname,
              lastName: response.data.data.employee.user.lastname,
              email: response.data.data.employee.user.email,
              phone: response.data.data.employee.user.phone.number,
              department: response.data.data.employee.department?.departmentName ?? null,
              supportingDepartment: response.data.data.employee.department?.supportingName ?? null,
              employeeId: response.data.data.employee.id,
              // wallet: response.data.data.organisation.wallet.balance,
              organisationName: response.data.data.employee.organisation.organisationName,
              organisationId: response.data.data.employee.organisation.id,
              imageUrl: response.data.data.employee.user.imageUrl || '',
            },
          });
          storeItem(import.meta.env.VITE_USERDETAILS, data);
          console.log("^^^^", data)
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
     async verify(verify: string): Promise<any> {
      try {
        const response = await userService.verify(verify);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    // async getUsers(): Promise<any> {
    //   try {
    //     const response = await userService.getUsers();
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    async getUsers(organisationId: number, pageSize: number, pageNumber: number): Promise<any> {
      try {
        const response = await userService.getUsers(organisationId, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },  
    
    async getNotifications(userId: number, pageSize: number, pageNumber: number): Promise<any> {
      try {
        const response = await userService.getNotifications(userId, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async getUserRole(userId: number): Promise<any> {
      try {
          const response = await userService.getUserRoleById(userId);
          console.log("Response from service:", response); 
          if (response.succeeded) {
              return response.data; 
          } else {
              throw new Error(response.message);
          }
      } catch (error: any) {
          console.error("Error in getUserRole:", error); 
          throw error; 
      }
  },     
    async fetchRoles(): Promise<any> {
      try {
        const response = await userService.fetchRoles();
        if (response.data) {
          return await Promise.resolve(response.data.data);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    
    async assignRole(userId: number, roleId: number): Promise<any> {
      try {
        const response = await userService.assignRole({ userId, roleId });
        if (response.data) {
          return await Promise.resolve(response.data);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async updateRole(userId: number, roleId: number): Promise<any> {
      try {
          const response = await userService.updateRole(userId, roleId);
          if (response.data) {
              return await Promise.resolve(response.data);
          } else if (response.response) {
              return await Promise.reject(response.response);
          } else {
              return await Promise.reject(response.message);
          }
      } catch (error: any) {
          return await Promise.reject(error);
      }
  },  

    async deleteUser(userId: string): Promise<any> {
      try {
        const response = await userService.deleteUser(userId);
        if (response.data) {
          return await Promise.resolve(response.data);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async create(data: Create): Promise<any> {
      try {
        const response = await userService.create(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async update(data: Update, id: string): Promise<any> {
      try {
        const response = await userService.update(data, id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async delete(id: string): Promise<any> {
      try {
        const response = await userService.delete(id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async updateUserImage(userId: number, formData: FormData): Promise<any> {
      try {
        const response = await userService.updateUserImage(userId, formData);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    }

  },
});

export default userStore;
